import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

function renderHeaderEditor(props: PropertyEditorProps) {
  const { control, onConfigChange, onBasicChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Header Settings</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Content
          <input
            type="text"
            value={(control.config?.content as string) || (control.label ?? '')}
            onChange={(e) => {
              onConfigChange('content', e.target.value || undefined);
              onBasicChange('label', e.target.value);
            }}
            className="af-properties-tab__input"
            placeholder="Header text"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Heading Level
          <select
            value={(control.config?.level as number) || 2}
            onChange={(e) => onConfigChange('level', parseInt(e.target.value, 10))}
            className="af-properties-tab__select"
          >
            <option value={1}>H1 — Page title (Largest)</option>
            <option value={2}>H2 — Section (default)</option>
            <option value={3}>H3 — Subsection</option>
            <option value={4}>H4</option>
            <option value={5}>H5</option>
            <option value={6}>H6 — Smallest</option>
          </select>
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Alignment
          <select
            value={(control.config?.alignment as string) || 'left'}
            onChange={(e) => onConfigChange('alignment', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Color
          <input
            type="color"
            value={(control.config?.color as string) || '#000000'}
            onChange={(e) => onConfigChange('color', e.target.value)}
            className="af-properties-tab__input"
            style={{ height: '36px' }}
          />
        </label>
      </div>
    </div>
  );
}

export const HeaderEditor: PropertyEditor = {
  type: 'header',
  label: 'Header',
  description: 'Configure heading content, level, alignment, and color',
  render: renderHeaderEditor,
};
